/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Api Documentation
 * Api Documentation
 * OpenAPI spec version: 1.0
 */

export type UserWithGroupsResponseTwoFactorType =
  (typeof UserWithGroupsResponseTwoFactorType)[keyof typeof UserWithGroupsResponseTwoFactorType];

export const UserWithGroupsResponseTwoFactorType = {
  EMAIL: 'EMAIL',
  NONE: 'NONE',
  OTP: 'OTP',
} as const;
